import { LoadableLazy } from '@confluence/loadable';

export { useModernizeChangeboardingActive } from './hooks/useModernizeChangeboardingActive';

export const ModernizeChangeboarding = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ModernizeChangeboarding" */ './ModernizeChangeboarding'
			)
		).ModernizeChangeboarding,
});
